import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import TrackingLink from 'Layout/NavBar/MegaMenu/Categories/TrackingLink';

export default function SimulationLinks({ setMegaMenuTab }) {
  return (
    <ul className="CategoriesMegaMenu__linksContainer" role="menu">
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/categories/simulation" id="categories-simulation" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="simulation-links.link.simulation" defaultMessage="Simulation" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/automobile-sim" id="categories-automobilesim" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="simulation-links.link.automobile-sim" defaultMessage="Automobile Sim" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/building-and-automation" id="categories-buildingandautomation" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="simulation-links.link.building-and-automation" defaultMessage="Building and Automation" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/colony-sim" id="categories-colonysim" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="simulation-links.link.colony-sim" defaultMessage="Colony Sim" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/dating-sim" id="categories-datingsim" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="simulation-links.link.dating-sim" defaultMessage="Dating Sim" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/farming-sim" id="categories-farmingsim" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="simulation-links.link.farming-sim" defaultMessage="Farming Sim" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/life-sim" id="categories-lifesim" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="simulation-links.link.life-sim" defaultMessage="Life Sim" />
        </TrackingLink>
      </li>
    </ul>
  );
}

SimulationLinks.propTypes = {
  setMegaMenuTab: PropTypes.func,
};

SimulationLinks.defaultProps = {
  setMegaMenuTab: () => { },
};
